import React from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadOfferDecisionFinancedAssets } from 'actions/actionCreators/offer/offerDecisionActions';
import { CollapseCard } from '@totalsoft/rocket-ui';
import WrappedFakeText from 'components/common/WrappedFakeText';
import ThumbUp from '@mui/icons-material/ThumbUp';
import { withTranslation } from 'react-i18next';
//sub-components
import OfferDecisionFinancedAssetsComponent from './OfferDecisionFinancedAssetsComponent';
import OfferDecisionFinancedAssetsSummary from './OfferDecisionFinancedAssetsSummary';

class OfferDecisionFinancedAssetsContainer extends React.PureComponent {
  state = {
    formLoading: false
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ formLoading: true });
    try {
      if (this.props.documentId) {
        await this.props.actions.loadOfferDecisionFinancedAssets(this.props.documentId, this.props.siteId);
      }
      this.setState({ formLoading: false });
    } catch (error) {
      // continue regardless of error
    }
  };

  render() {
    const { formLoading } = this.state;
    const { t, financedAssets } = this.props;
    return (
      <CollapseCard
        icon={ThumbUp}
        iconColor='primary'
        title={t('OfferEdit.Decision.FinancedAssets.Title')}
        header={<OfferDecisionFinancedAssetsSummary financedAssets={financedAssets} />}
        toggleOnHeaderClick
        content={
          formLoading || !financedAssets ? <WrappedFakeText lines={6} /> : <OfferDecisionFinancedAssetsComponent assets={financedAssets} />
        }
      />
    );
  }
}

OfferDecisionFinancedAssetsContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  financedAssets: PropTypes.array,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    financedAssets: state.currentOffer.decision.financedAssets
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadOfferDecisionFinancedAssets
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferDecisionFinancedAssetsContainer);
